var exports = {
  "x6": "x804f0401--3b1e12--button",
  "Pf": "x804f0401--3b1e12--label",
  "kv": "x804f0401--3b1e12--checkbox",
};

module.exports = exports;
